import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { FindFundingRequestByIdQueryResponse, FindFundingRequestByIdQueryParams, FindFundingRequestById400, FindFundingRequestById401, FindFundingRequestById403, FindFundingRequestById404, FindFundingRequestById410, FindFundingRequestById422, FindFundingRequestById429, FindFundingRequestById500 } from "../types/FindFundingRequestById";

export const findFundingRequestByIdQueryKey = (params: FindFundingRequestByIdQueryParams) =>     [{url:`/api/credit-flow-backend/v1/funding`},...(params ? [params] : [])] as const;
      export function findFundingRequestByIdQueryOptions <TData = FindFundingRequestByIdQueryResponse, TError = FindFundingRequestById400 | FindFundingRequestById401 | FindFundingRequestById403 | FindFundingRequestById404 | FindFundingRequestById410 | FindFundingRequestById422 | FindFundingRequestById429 | FindFundingRequestById500>(params: FindFundingRequestByIdQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = findFundingRequestByIdQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/credit-flow-backend/v1/funding`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/credit-flow-backend/v1/funding
 */

export function useFindFundingRequestById <TData = FindFundingRequestByIdQueryResponse, TError = FindFundingRequestById400 | FindFundingRequestById401 | FindFundingRequestById403 | FindFundingRequestById404 | FindFundingRequestById410 | FindFundingRequestById422 | FindFundingRequestById429 | FindFundingRequestById500>(params: FindFundingRequestByIdQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? findFundingRequestByIdQueryKey(params);

  const query = useQuery<TData, TError>({
    ...findFundingRequestByIdQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
